import React from 'react';
import { Button, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useAuthStore } from '../features/auth/store/authStore';
import { useSupportViewStore } from '../features/host/store/supportViewStore';
import { useExitTenantSupportView } from '../features/host/hooks/useSupportView';

const { Text } = Typography;

const ImpersonationBanner: React.FC = () => {
  const viewingCompanyName = useAuthStore((state) => state.user?.viewingCompanyName);
  const operatorUser = useSupportViewStore((state) => state.operatorUser);
  const exitMutation = useExitTenantSupportView();

  const companyLabel = viewingCompanyName ?? 'this organization';
  const operatorLabel = operatorUser?.email ?? 'host operator';

  return (
    <header className="cp-impersonation-topbar" role="alert" aria-live="assertive">
      <div className="cp-impersonation-topbar__message">
        <WarningOutlined className="cp-impersonation-topbar__icon" aria-hidden />
        <Text strong className="cp-impersonation-topbar__title">
          IMPERSONATION MODE ACTIVE
        </Text>
        <Text className="cp-impersonation-topbar__detail">
          Viewing <Text strong>{companyLabel}</Text> as {operatorLabel}
        </Text>
      </div>
      <Button
        danger
        size="small"
        className="cp-impersonation-topbar__exit"
        onClick={() => exitMutation.mutate()}
        loading={exitMutation.isPending}
      >
        Exit impersonation
      </Button>
    </header>
  );
};

export default ImpersonationBanner;
